export const SnackbarVariants = {
    DEFAULT: 'default',
    ERROR: 'error',
};

export default SnackbarVariants;
